mutation TravelAuthorizationApprovalRevoke(
  $input: TravelAuthorizationApprovalRevokeInput!
) {
  travelAuthorizationApprovalRevoke(input: $input) {
    revokedApprovalEntity
  }
}
